import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import HighlightText from '../components/HighlightText'
import TrustBox from '../components/TrustBox'
import { useMedia } from 'react-use'

gsap.registerPlugin(MorphSVGPlugin)
window.requestAnimationFrame = window.requestAnimationFrame.bind(window) // Reqd for IE Edge in dev
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(SplitText)

const TrustPilotReviews = (props) => {
    const isMobile = useMedia('(max-width: 992px)')
    const container = useRef(null)
    const scene1 = useRef(null)
    const scene2 = useRef(null)
    const heading = useRef(null)
    const subHeading = useRef(null)

    useEffect(() => {
        const morph = gsap.timeline()
        morph.to(scene1.current, {
            morphSVG: {
                shape: scene2.current,
                type: 'linear'
            },
            scrollTrigger: {
                trigger: container.current,
                start: 'top center',
                end: '+=550',
                scrub: 0.5
            }
            // ease: "back.inOut(3)",
        })

        if (!isMobile) {
            const headingText = new SplitText(heading.current, { type: 'lines' })
            const subText = new SplitText(subHeading.current, { type: 'lines' })

            gsap.fromTo([...headingText.lines, ...subText.lines], {
                opacity: 0,
                y: 80
            }, {
                duration: 1,
                stagger: 0.1,
                opacity: 1,
                y: 0,
                scrollTrigger: {
                    trigger: container.current,
                    start: 'top center'
                }
            })
        }
    })

    return (
        <div ref={container} className='trustpilot-reviews mt-3 mt-lg-0'>
            <div className='reviews'>
                <div className='bg'>
                    <svg viewBox='0 0 1207 883' className='svg'>
                        <path ref={scene1} transform='translate(0.000000, -866.000000)' fill='#EFF3F4' d='M0,866 C238.698113,870.602039 292.360243,1037.13788 516.387864,1066.42503 C740.415485,1095.71219 998.788685,962.553001 1143.1,1123.5 C1287.41132,1284.447 1166.2,1562.87371 980.781276,1647.293 C795.362551,1731.71228 222.43551,1651.75567 0,1749 C0,1538.46715 0,974.342185 0,866 Z' />
                        <path ref={scene2} style={{ display: 'none' }} d='M0,967.59056 C152.096016,958.064283 292.360243,1066.52105 516.387864,1095.80821 C740.415485,1125.09536 975.438969,1006.61566 1119.75028,1167.56266 C1264.0616,1328.50966 1156.74204,1612.43354 980.781276,1647.293 C804.820517,1682.15245 222.43551,1651.75567 0,1749 C0,1538.46715 0,1075.93274 0,967.59056 Z' />
                    </svg>
                </div>
                <div className='review-container'>
                    <TrustBox />
                </div>
            </div>
        </div>
    )
}

export default TrustPilotReviews



// WEBPACK FOOTER //
// ./resources/js/modules/TrustPilotReviews.js